module.exports = __webpack_public_path__ + "static/pinkvelourfrill-a9975ec81e5a837ddd3a01a5219a4838.jpeg";